import customSelect from "custom-select";

const initCustomSelects = function (inputSelector, containerSelector) {
  const realSelects = document.querySelectorAll(inputSelector);
  const container = document.querySelector(containerSelector);

  if (realSelects && container) {
    if (!container.classList.contains("initialised")) {
      realSelects.forEach((s) => {
        let realSelectOptions = s.querySelectorAll("option");
        let tempSelect = document.createElement("select");
        tempSelect.setAttribute("class", "temp-select");

        realSelectOptions.forEach((o) => {
          let option = document.createElement("option");
          option.innerText = o.innerText;
          option.setAttribute("value", o.getAttribute("value"));
          tempSelect.appendChild(option);
        });

        container.appendChild(tempSelect);
        container.classList.add("initialised");
        let ts = customSelect(tempSelect)[0];
        ts.container.setAttribute("data-attribute", s.getAttribute("name"));
        ts.container.setAttribute("data-option-count", realSelectOptions.length);
        
        ts.select.addEventListener("change", (e) => {
          s.value = e.target.value;
          let ev = document.createEvent("HTMLEvents");
          ev.initEvent("change", true, true);
          s.dispatchEvent(ev);
        });
      });
    } else {
      console.log('DSA Selects already initalised.')
    }
  }
};

const initVariationSelect = function () {
  // Here's what we're learning
  // We can't just change the value of the select,
  // but we need to update some internal data structure too.
  // If you just update the value of the select and submit
  // it throws the "Invalid value posted" error
  // A way to do this seems to fire a native change event on
  // the select after we've changed the value.

  // I think the reason customSelect fails if we
  // naively run it on the Woo variation select is that
  // it changes the DOM which messes up Woo's event handlers.

  // The workaround is this:
  // 1. We make a temporary select with the same options as
  // the variation select and append it to the same container.

  const realSelect = document.querySelector("#pa_size");

  if (realSelect) {
    const realSelectOptions = realSelect.querySelectorAll("option");
    const container = document.querySelector(".variations .value");

    const tempSelect = document.createElement("select");
    tempSelect.setAttribute("id", "temp-select");

    realSelectOptions.forEach((o) => {
      let option = document.createElement("option");
      option.innerText = o.innerText;
      option.setAttribute("value", o.getAttribute("value"));
      tempSelect.appendChild(option);
    });
    container.appendChild(tempSelect);

    // 2. We run customSelect on our new select
    const tempSelectCustom = customSelect("#temp-select")[0];

    // 3. On change, we update the real select's value
    // and trigger its native "change" event so WooCommerce
    // knows about it.
    tempSelectCustom.select.addEventListener("change", (e) => {
      realSelect.value = e.target.value;
      let ev = document.createEvent("HTMLEvents");
      ev.initEvent("change", true, true);
      realSelect.dispatchEvent(ev);
    });

    // 4. We hide the real select with CSS.
    // We have to do this here, after everything else,
    // so as not to interfere with WooCommerce's event binding.
    realSelect.style.visibility = "hidden";
    realSelect.style.position = "absolute";
    realSelect.style.top = "0";
  }
};

export { initCustomSelects, initVariationSelect };
